// extracted by mini-css-extract-plugin
var _1 = "forgot-sXLRR";
var _2 = "reset-UgTvE";
var _3 = "title-HwyBQ";
export { _1 as "forgot", _2 as "reset", _3 as "title" }
